// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___jVxr","withFallback":"withFallback__3smQU","edit":"edit__eKYe-","fallback":"fallback__2WDVc","fallbackInner":"fallbackInner__AiWr5"};